<app-modal
  [title]="getTitle()"
  [saveButtonName]="getSaveButtonName()"
  [cancelButtonName]="getCancelButtonName()"
  [shouldSaveBeDisabled]="!isNextAvailable() || blockInput"
  (save)="onNextButtonClick()"
  (cancelClick)="onCancelButtonClick()"
  customCancelBehavior
  [timestamp]="isEdit() ? data.item : null"
>
  <ng-container body>
    <main [class.block-input]="blockInput">
      @switch (formStage) {
        @case (FormStages.TYPE) {
          <app-tree-form-select-node-type [data]="data"></app-tree-form-select-node-type>
        }
        @case (FormStages.NAME_AND_ICON) {
          <p>{{ 'TREE.PICK_NAME' | translate }}</p>
          <app-tree-form-name-input [data]="data"></app-tree-form-name-input>
          @if (displayRootDeviceWarning()) {
            <span class="root-device-message">{{
              'TREE.DEVICE_IN_ROOT_IS_NOT_RECOMMENDED' | translate
            }}</span>
          }
          <p>{{ 'TREE.CHOOSE_ICON' | translate }}</p>
          <app-tree-form-icon-select [data]="data"></app-tree-form-icon-select>
        }
      }
    </main>
  </ng-container>
</app-modal>
